// casesData.js
export const cases = [
    {
        title: "Readdle – Documents App",
        subtitle: "Improving Document app with AI",
        description: "We created a RAG system for Readdle's Documents app to help users easily search through many text files on their devices.  Our solution quickly finds files, provides brief summaries, and allows users to ask questions about the content. The system works directly on the device, ensuring fast and optimized performance.  It supports multiple languages and handles large text contexts effectively, covering most files. Powered by the Mistral LLM, this tool makes managing text files simpler and more efficient.",
        image: "/images/projects/readdle.jpg",
        category: "ai",
        techStack: ["Python", "AI", "Rag"]
    },
    {
        title: "Bowlero – AI Assistant",
        subtitle: "AI-driven customer support assistant",
        description: "Bowlero Corp is the world's largest bowling center owner and operator, with 8,000+ team members, 12,000+ lanes, and 28 million annual guests.  We created an AI-assistant (STT and TTS) for Bowlero, using advanced tools like LLaMa2, LangChain, and Python. This AI-driven solution simplifies customer interactions, including lane reservations and event planning. Hosted on AWS, the solution guarantees reliable high-demand performance using advanced orchestration software. Featured in our pitch deck, it highlights our proficiency in creating personalized AI assistants and customer support solutions.",
        image: "/images/projects/bowlero.jpg",
        category: "ai",
        techStack: ["Python", "AI",]
    },
    {
        title: 'Skylum – AI Photo Library',
        subtitle: 'AI Search for Luminar NEO',
        description: 'We developed an AI search feature for Luminar NEO that allows users to search through photos and videos using abstract text queries.  It works on both Windows and Mac, supports multiple languages, and operates directly on the device. It delivers over 85% search accuracy across all photo and video formats, handling abstract queries with ease. The AI search is based on a CLIP model, optimized for minimal space and resource usage.',
        image: '/images/projects/skylum.jpg',
        category: 'ai',
        techStack: ["Python", "AI", "Rag"]
    },
    {
        title: 'Soulmate – AI Dating Companion',
        subtitle: 'Chat Solution for the Entertainment Segment',
        description: 'We developed a chat solution for the entertainment industry. We managed the entire backend, including data collection and processing, and designed the interaction rules. We integrated ChatGPT to serve as the users conversational partner, enabling dynamic and natural conversations.The system can handle a wide range of queries, offering relevant responses and supporting high volumes of user interactions. It also supports multiple languages and ensures data privacy and security.This chat solution enhances user engagement, providing an intuitive and enjoyable experience for users worldwide.',
        image: '/images/projects/soulmate.jpg',
        category: 'ai',
        techStack: ["Python", "AI",]
    },
    {
        title: 'TotalCheq – Finance Copilot',
        subtitle: 'is a company specializing in warehouse logistics.',
        description: 'We developed a solution for product registration and warehouse inventory accounting as well as integrated the solution into the existing accounting system. When new product names appear in the warehouse, the algorithm automatically self-learns to recognise them.',
        image: '/images/projects/totalcheq.jpg',
        category: 'ai',
        techStack: ["Python", "AI",]
    },
    {
        title: 'Respindle – E-commerce AI',
        subtitle: 'Respindle is a pioneering medtech startup.',
        description: 'We created AI tech for predicting oocyte aneuploidy risk via non-invasive image analysis. Its cost-effective, accessible, and can benefit 1.5 million women yearly by improving assisted reproduction and reducing pregnancy complications.',
        image: '/images/projects/respindle.jpg',
        category: 'ai',
        techStack: ["Python", "AI",]
    },
    {
        title: 'Lookout – Secure the Human Layer.',
        subtitle: 'Contain the Mobile Threat.',
        description: 'Your people are the target. Their mobile devices have become the delivery vehicle for modern attacks. Lookout’s AI-powered platform defends against phishing, social engineering, and account takeovers—providing visibility and control that traditional security tools miss.',
        image: '/images/projects/lookout.jpg',
        category: 'ai',
        techStack: ["Python", "Mobile",]
    },
    {
        title: 'AI Coding assistant',
        subtitle: 'AI Coding assitant (VS Code extension) for a stelath startup.',
        description: 'AI Coding Assistant is a smart VS Code extension designed to streamline the developer workflow. It features an autonomous agent mode for context-aware code generation, refactoring, and debugging. Integrated with MCP (Model Control Plane) to dynamically route requests to optimal LLMs based on task complexity.  Runs locally for privacy-first development, with minimal latency and deep project awareness',
        image: '/images/projects/ai_agent.gif',
        category: 'ai',
        techStack: ["Python", "AI",]
    },
    {
        title: 'Hideez – Passwordless Authentication and MFA Solutions.',
        subtitle: 'Enhance Your Business Security With Universal Passwordless Authentication Tools.',
        description: 'all in one personal security app with Bluetooth available key as a keystore for features likeSmart Lock, Password Manager, Biometric identification, Touch guard, Secure photos and many more.Leaded new release development. Made Bluetooth communication 3 times faster with batching.Reduced power consumption with optimizations – 4 times less energy.',
        image: '/images/projects/hideez.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile",]
    },
    {
        title: 'Military Pay by Military.com.',
        subtitle: 'Mobile app for United States Army.',
        description: 'The Army, Navy, Marine Corps, Air Force, Coast Guard, Coast Guard, and National Guard mobile app for calculating your service pay. The Military.com Pay app makes it easy to calculate your monthly and annual pay with up-to-date payroll information, including current BAH, BAS, and special pay. You can also easily add submarine pay, labor pay, or family separation pay. Just enter your information and well figure out the rest.',
        image: '/images/projects/militaryPay.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile",]
    },
    {
        title: 'dacadoo - healthcare application',
        subtitle: 'One of the first and the best in market healthcare applications.',
        description: 'Lots of modules – starting from messaging, workout tracking and navigation architecture to integration with own and third-party devices (step-trackers, hart rate monitors) via Bluetooth and developing integrated apps for Galaxy Gear Tizen and Android Wear smart-watches.',
        image: '/images/projects/dacadoo.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile", "Web",]
    },
    {
        title: 'BabyKeep',
        subtitle: 'Application for child-care',
        description: 'Application for child-care outsourcing company to control, motivate and manage their employees and manage children skills development cycles.',
        image: '/images/projects/babyKeep.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin","Mobile",]
    },
    {
        title: 'BigPay – financial services',
        subtitle: 'Wallet applications for AirAsia customers.',
        description: 'BigPay lets you manage your finances anywhere and has one goal - to provide you with the financial services you need to improve your standard of living, one transaction at a time. With the flexibility of a mobile app and a physical card, we give you the opportunity to improve your spending habits in one place.',
        image: '/images/projects/bigPay.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile",]
    },
    {
        title: 'Tango',
        subtitle: 'Live Streaming and Video Chat.',
        description: 'Tango is a streaming app for online communication and new interesting acquaintances. More than 400 million people from different countries use Tango. Become a professional streamer, communicate with subscribers and fans - earn money on your talents',
        image: '/images/projects/tango.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile"]
    },
    {
        title: 'OMGames',
        subtitle: 'Mobile games store for Softonic for about 200 Million users.',
        description: 'Search, categorize, install games from one of the largest games market. Implemented from scratch. Lazy loading, unit testing, CI delivery – Jenkins based builds.',
        image: '/images/projects/omgames.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile"]
    },
    {
        title: 'Military News by Military.com',
        subtitle: 'Mobile app for United States Army.',
        description: 'Military.com delivers the best Army, Navy, Marine Corps, Space Force, Air Force, Coast Guard, and National Guard news, as well as military news headlines, pay, benefits, and discounts. Choose the topic feeds that are most relevant to you to customize your experience and never miss an update from the largest military and veteran organization on the go.',
        image: '/images/projects/militaryNews.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile"]
    },
    {
        title: 'On-line Mobile Banking',
        subtitle: 'Mobile banking application',
        description: 'Best in eastern Europe mobile banking. Large amount of functionality, using newest android features. Implemented security side for this banking app - with encrypted DB, 2-factor auth and more.',
        image: '/images/projects/mobBanking.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile"]
    },
    {
        title: 'Ukraine National Lottery',
        subtitle: 'Android application that allows customers to play lottery from any place at any time',
        description: 'Android application that allows customers to play lottery from any place at any time.',
        image: '/images/projects/unl.jpg',
        category: 'other',
        techStack: ["Java", "Swift", "Kotlin", "Mobile"]
    },
    {
        title: 'Floroteka',
        subtitle: 'Online marketplace for flowers and related products',
        description: 'An e-commerce platform that connects multiple sellers offering fresh flowers, bouquets, plants, and related accessories. As a marketplace, Floroteka provides customers with a wide choice from various vendors, secure payment options, convenient delivery services, and seasonal offers for personal or corporate occasions.',
        image: '/images/projects/floroteka.jpg',
        category: 'other',
        techStack: ["JavaScript", "Web"]
    },
    {
        title: 'FlowerPot',
        subtitle: 'Mobile app for flower and indoor plant delivery',
        description: 'A mobile app and online store offering a wide selection of designer bouquets, floral arrangements, and potted plants. Features convenient filters for quick ordering, secure payment options including Apple Pay and Google Pay, same-day delivery or in-store pickup, courier tracking, ready-made combo sets with plants and pots, as well as extra gifts like desserts and greeting cards. Includes a personal account, loyalty program, and is available for both iOS and Android.',
        image: '/images/projects/flawerpot.jpg',
        category: 'other',
        techStack: ["Flutter", "Web", "Mobile"]
    },
    {
        title: 'VPP',
        subtitle: 'Mobile app for managing participation in a Virtual Power Plant',
        description: 'A mobile application that lets users monitor, manage, and monetize their home energy systems by joining a Virtual Power Plant (VPP). The app consolidates data from solar and battery systems, provides historical performance insights, sends smart alerts, and enables users to export surplus energy to the grid for financial rewards—all through a single, user-friendly mobile interface available on iOS and Android.',
        image: '/images/projects/vpp.jpg',
        category: 'other',
        techStack: ["Flutter", "Mobile"]
    },
];
